export interface AssistantRouteContext {
  currentPage: string;
  selectedProject: string;
  reportId?: number;
}

const pageCategories = new Set([
  'dashboard', 'reports', 'report', 'artifacts', 'market', 'gtm', 'risks',
  'actions', 'funding', 'admin', 'settings', 'my-documents', 'programs',
  'bounties', 'achievements', 'analytics', 'impact-evaluator', 'wayfinder',
  'safeguard', 'geo', 'geo-analyzer', 'impact-wizard', 'trivia',
  'ai-readiness', 'sustainability-quiz', 'game-changer', 'community',
  'referral', 'leaderboard', 'profile', 'features', 'pricing', 'help-center',
  'concept-validator', 'get-started',
]);

// Navigation hints only. Ownership and report access remain server-verified.
export function getAssistantRouteContext(pathname: string, search: string): AssistantRouteContext | null {
  let path: string;
  try { path = decodeURIComponent(pathname).toLowerCase(); } catch { return null; }
  if (/^\/(?:login|signup)(?:\/|$)/.test(path)
    || /^\/shared\/report(?:\/|$)/.test(path)
    || /^\/trivia\/embed(?:\/|$)/.test(path)) return null;

  const category = path.split('/')[1];
  const context: AssistantRouteContext = {
    currentPage: pageCategories.has(category) ? category : 'app',
    selectedProject: 'all',
  };
  if (path === '/dashboard' || path === '/dashboard/') {
    const projects = new URLSearchParams(search).getAll('project');
    const project = projects.length === 1 ? projects[0].trim() : '';
    const hasControlCharacter = Array.from(project).some(character => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127);
    if (project && project.length <= 500 && !hasControlCharacter) {
      context.selectedProject = project;
    }
  }
  const report = /^\/(?:report|impact-evaluator|wayfinder|safeguard|geo)\/([1-9]\d*)\/?$/.exec(path);
  if (report && Number.isSafeInteger(Number(report[1]))) context.reportId = Number(report[1]);
  return context;
}
